import Single_Dashboard_Image from "../../assets/Single_Dashboard.png";

export const setToken = (token, userId, role, account_id) => {
  localStorage.setItem("jwtToken", token);
  localStorage.setItem("isUserLoggedIn", true);
  localStorage.setItem("userId", userId);
  localStorage.setItem("role", role);
  if (account_id && account_id !== "None") {
  localStorage.setItem("account_id", account_id);
  }
};

// Function to get the JWT token from local storage
export const getToken = () => {
  return localStorage.getItem("jwtToken");
};
export const getAccountId = () => {
  return localStorage.getItem("account_id");
}

export const getUserId = () => {
  return localStorage.getItem("userId");
};

export const getUserRole = () => {
  return localStorage.getItem("role");
};
// Function to remove the JWT token from local storage
export const verifyLogin = () => {
  if (!localStorage.getItem("isUserLoggedIn")) {
    return false;
  }

  return true;
};

export const removeToken = (onRemoved) => {
  localStorage.removeItem("jwtToken");
  localStorage.removeItem("isUserLoggedIn");

  if (onRemoved && typeof onRemoved === "function") {
    onRemoved();
  }
};

export const FetchUserDashboards = async ( setUserDashboards ) => {
  const apiUrl = process.env.REACT_APP_API_URL;
  try {
    const response = await fetch(
      `${apiUrl}/auth/get_user_dashboard/?user_id=${getUserId()}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    const data = await response.json();
    const user_dashboard = data.results.dashboard_details.map((x) => {
      const name = x.dashboard_name;
      const dashboardName = x.data_reference;
      const s3_bucket_name = x.s3_bucket_name;
      const s3_prefix = x.s3_prefix;
      const default_start_date =
        x.details_object !== null && x.details_object["default_start_date"];
      const default_end_date =
        x.details_object !== null && x.details_object["default_end_date"];

      return {
        name: name,
        dashboardName: dashboardName,
        s3_bucket_name: s3_bucket_name,
        s3_prefix: s3_prefix,
        icon: "fa-solid fa-chart-simple p-2 ",
        image: Single_Dashboard_Image,
        path: `/dashboard?dashboard_name=${dashboardName}`,
        default_start_date: default_start_date,
        default_end_date: default_end_date,
      };
    });
    setUserDashboards(user_dashboard); // update state with user_dashboard;
  } catch (error) {
    console.log(error);
  }
};
